<template>
<div class="main-area py-4">
    <div class="md:px-8  md:pt-8 form-design-color md:m-6" id="alert_image_overlay">
            <div class="text-center pt-8 md:pt-0 login-selection-header pb-4">
                Sign In
            </div>
            <div class="flex login-selection-content w-full justify-evenly">
              <div v-if="!isBuyer" style="cursor:pointer;" @click="isFreelancerSelected(false, true)" class="buyer-selection w-45p md:w-2/5">
                <div class="flex items-center justify-center">
                  <img  class="p-2" src="@/assets/images/buyer-unhg.png">
                </div>
                <div>
                  <div class="selection-content-text text-center">
                    I'm a Buyer
                  </div>
                  <div class="checkbox_image_overlay">
                    <img  class="checkbox_image_buyer"  src="@/assets/images/buyer-uncheck.png">
                  </div>
                </div>
              </div>
              <div v-if="isBuyer" style="cursor:pointer;" @click="isFreelancerSelected(false, true)" class="buyer-selection buyer-checked w-45p md:w-2/5">
                <div class="flex items-center justify-center">
                  <img  class="p-2"  src="@/assets/images/buyer-hg.png">
                </div>
                <div>
                  <div class="selection-content-text text-center highlighted-text">
                    I'm a Buyer 
                  </div>
                  <div class="checkbox_image_overlay">
                    <img  class="checkbox_image_buyer"  src="@/assets/images/buyer-checkbox.png">
                  </div>
                </div>
              </div>
              <div v-if="isFreelancer" style="cursor:pointer;" @click="isFreelancerSelected(true, false)"  class="freelancer-selection freelancer-checked w-45p md:w-2/5 bg-white">
                <div class="flex items-center justify-center ">
                  <img  class="p-2"  src="@/assets/images/freelancer-hg.jpg">
                </div>
                <div>
                  <div class="selection-content-text text-center highlighted-text">
                    I'm a BuyHive <br/> Sourcing Expert
                  </div>
                  <div class="checkbox_image_overlay">
                    <img  class="checkbox_image_freelancer"  src="@/assets/images/freelancer-checkbox.png">
                  </div>
                </div>
              </div>
              <div v-if="!isFreelancer" style="cursor:pointer;" @click="isFreelancerSelected(true, false)" class="freelancer-selection w-45p md:w-2/5">
                <div class="flex items-center justify-center ">
                  <img  class="p-2"  src="@/assets/images/freelancer-unhg.png">
                </div>
                <div>
                  <div class="selection-content-text text-center">
                    I'm a BuyHive <br/> Sourcing Expert
                  </div>
                  <div class="checkbox_image_overlay">
                    <img  class="checkbox_image_freelancer"  src="@/assets/images/freelancer-uncheck.png">
                  </div>
                </div>
              </div>
            </div>
            <div class="flexbox text-center pt-4 pb-4 md:pt-2 md:pb-2 md:pt-6">
                  <button :disabled="!isBuyer&&!isFreelancer" @click="openLoginModalpopup()" class="new-app-btn mt-6 sm:mt-0" :class="!isBuyer&&!isFreelancer ? 'disable-btn' : 'bg-blue'">
                    Sign In
                  </button>
            </div>
            <div class="dont-have-account flexbox text-center py-4 font-semibold">
              Don’t have an account? <a
                @click="createAccount()"
                class="text-blue underline cursor-pointer"
              > Create one!</a>
            </div>
    </div>
</div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
export default {
  name: 'LoginSelection',
    beforeRouteEnter: async (to, from, next) => {
    document.title = 'User Sign In',
    next()
  },
  data() {
    return{
      isFreelancer : false,
      isBuyer: false,
      freelancerURL: process.env.VUE_APP_FREELANCER_HOME_PATH,
      baseURL: process.env.VUE_APP_SERVER_BASE_URL,
      policyLink:  '/register' 
    }
  },
  watch: {
    ...mapGetters(['LoginSelectionMode'])
    },
  methods: {
    ...mapActions ([ 'openLoginSelectionModal', 'openLoginModal', 'LoginSelectionMode', 'openSignupSelectionModal' ]),
    isFreelancerSelected(freelancer, buyer) {
      this.isFreelancer = freelancer
      this.isBuyer = buyer
    },
    closeLoginSelectionModal() {
      this.openLoginSelectionModal(false)
      if (this.$route.query.authModal || this.$route.query.prev)
        this.$router.replace({ 'query': null })
    }, 
    openLoginModalpopup() {
      if(this.isBuyer)  {
        this.LoginSelectionMode('buyer')
      } else {
        this.LoginSelectionMode('freelancer')
      }
      if(this.$route.query.redirect_url) {
        this.$router.push({name: 'LoginFormv2', query : {redirect_url: this.$route.query.redirect_url}})  
      } else {
        this.$router.push({name: 'LoginFormv2'})
      }
    },
    createAccount() {
        if(this.isBuyer) {
          window.location = `${process.env.VUE_APP_BUYER_HOME_PATH}/register`
        } else if(this.isFreelancer) {
          window.location = `${process.env.VUE_APP_FREELANCER_HOME_PATH}/register`
        } else {
          this.$router.push({name: 'SignupSelection'})
        }
      
    }
  },
  created() {
    if (this.$route.query.role === 'freelancer') this.isFreelancer = true
    if (this.$route.query.role === 'buyer') this.isBuyer = true
    if (this.$route.query.intent === 'login') {
      this.$router.replace({ 'query': null })
      if(this.isBuyer || this.isFreelancer) {
        this.openLoginModalpopup()
      }
    }
      
  },
}
</script>

<style lang="scss" scoped>

.new-app-btn {
  @apply rounded-full px-16 py-2 text-white;
  font-size: 20px;
  line-height: 30px;
  font-weight: 500;
}
#alert_image_overlay {
  margin: 4em auto;
  width: 40%;
  position: relative;
  color: #024457;
  // z-index: 1001;
   @media (max-width: 768px) {
    width: 85%;
  }
}
.disable-btn {
  background-color: #C4C4C4;
}
.disable-text {
  color: #C4C4C4;
}
.highlighted-text {
  font-weight: 500;
}
.selection-content-text {
  @media(max-width: 768px) {
  font-weight: 500;
  font-size: 12px;
  line-height: 14.4px;
  }
  font-weight: 400;
  font-size: 16px;
  line-height: 19.2px;
}
.checkbox_image_overlay {
  border-radius: 8px;
  padding: 1em;
  position: relative;
  color: #024457;
  font-family: Arial;
  @media (max-width: 768px) {
    top: 2px;
    padding: 1.25em;
    
  }
  // z-index: 1001;
}
.checkbox_image_overlay .checkbox_image_freelancer {
  position: absolute;
  top: 0px;
  right: 8px;
  
  z-index: 1;
  @media (max-width: 768px) {
    top:5px;
  }
}
.checkbox_image_overlay .checkbox_image_buyer {
  position: absolute;
  top: 19px;
  right: 8px;
  
  z-index: 1;
}

#alert_image_overlay #alert_header {
  position: absolute;
  top: 45px;
  left: 40px;
  color: #2D2D84;
  font-size: 60px;
  line-height: 60px;
  font-weight: 600;
  font-style: Avenir;

}
#alert_image_overlay #alert_content {
  position: absolute;
  top: 170px;
  left: 40px;
  color: #243943;
  font-size: 24px;
  line-height: 32.78px;
  font-style: Avenir;

}
#alert_image_overlay #alert_button {
  position: absolute;
  top: 250px;
  left: 40px;
  background-color: #2D2D84;
  color: white;
  font-size: 24px;
  line-height: 40px;
  font-style: Avenir;

}
.buyer-selection {
  border: 1px solid #C4C4C4;
  border-radius: 4px;
}
.freelancer-checked {
  background: #FFFFFF;
  border: 1px solid #8BC53F !important;
  box-shadow: 1px 1px 6px 1px #C5DFE2;
  border-radius: 4px;
}
.buyer-checked {
  background: #FFFFFF;
  border: 1px solid #00B2C9 !important;
  box-shadow: 1px 1px 6px 1px #C5DFE2;
  border-radius: 4px;
}
.dont-have-account {
  @media(max-width: 768px) { 
    font-size: 16px;
    line-height: 16px;
  }
      font-size: 18px;
    line-height: 27px;
    font-weight: 500;
}
.freelancer-selection {
  border: 1px solid #C4C4C4;
  border-radius: 4px;
}
.login-selection-header {
  @media(max-width: 768px) { 
     font-family: 'Avenir LT Pro';
    font-weight: 500;
    font-size: 24px;
    line-height: 26px;
  }
      font-weight: 500;
    display: flex;
    justify-content: center;
    color: #00B2C9;
    font-family: 'Avenir LT Pro';
    // font-weight: 500;
    font-size: 28px;
    line-height: 38px;
}
.form-design-color{
  background: white;
  border: 1px solid #C4C4C4;
  border-radius: 4px;
}
</style>